// extracted by mini-css-extract-plugin
export default {"bg":"Header_bg__kGAGA","gradient":"Header_gradient__yVbfs","after":"Header_after__kOWXf","btn":"Header_btn__1Nqym"};